export const twoView = `
<svg width="36" height="33" viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="10" width="11" height="11" rx="1" fill="white"/>
    <rect x="18" y="10" width="11" height="11" rx="1" fill="white"/>
</svg>`;